export default "__VITE_ASSET__CbsXSjWJ__"